import React from 'react';
import { Table } from 'antd';
import { User, Phone, MapPin } from 'lucide-react';

interface UsedCallsTableProps {
  dataSource: any[];
  columns: any[];
  loading?: boolean;
}

const UsedCallsTable: React.FC<UsedCallsTableProps> = ({
  dataSource,
  columns,
  loading = false,
}) => {
  // Add SN column to the beginning of columns
  const columnsWithSR = [
    {
      title: "SrNo.",
      dataIndex: "srNo",
      key: "srNo",
      width: 100,
      align: "left",
      render: (_: any, __: any, index: number) => (
        <span style={{ fontSize: 12, fontWeight: 500, color: "#6b7280" }}>
          {index + 1}
        </span>
      ),
    },
    ...columns,
  ];

  return (
    <div className="slide-up-enter ">
      <Table
        dataSource={dataSource}
        columns={columnsWithSR}
        loading={loading}
        pagination={false}
        scroll={{ x: 'max-content' }}
        size="middle"
        className="custom-data-table"
        style={{
          background: '#fff',
          borderRadius: '8px',
        }}
        rowClassName={(record, index) =>
          index % 2 === 0 ? 'data-table-row-light' : 'data-table-row-dark'
        }
      />
    </div>
  );
};

export default UsedCallsTable;
